export const TABS_JUDICIAL_HEARINGS = [
  'Заседания по делу',
  'Информация о деле',
];
